import React from "react";
import { Container } from "react-bootstrap";
import CertificateBannerImg from "../assets/img/inner-banner/Certificate.webp";
const CertificateBanner = () => {
  return (
    <>
      <section>
        <Container fluid className="bannersection position-relative p-0">
          <img
            src={CertificateBannerImg}
            alt="Service banner"
            className="w-100 h-100 object-fit-cover about-banner-img"
          />
          <div className="textoverlay d-flex flex-column justify-content-center align-items-center position-absolute top-0 w-100 h-100 text-center">
            {/* <h1 className="heading">
              The Evolution of Diamond Quality Assessment
            </h1> */}
          </div>
        </Container>
      </section>
    </>
  );
};

export default CertificateBanner;
